import { Reveal } from "@/components/shared/Reveal";
import { WORKSHOP } from "@/config/workshop";
import { Summary } from "./Summary";
import { BookingForm } from "./BookingForm";
import { ValueStack } from "./ValueStack";

export function BookingSection() {
  const waLink = `https://wa.me/${WORKSHOP.contact.whatsapp}?text=${encodeURIComponent(
    WORKSHOP.booking.whatsappText,
  )}`;
  const mailLink = `mailto:${WORKSHOP.contact.email}?subject=${encodeURIComponent(
    WORKSHOP.booking.emailSubject,
  )}`;

  return (
    <section className="buchung" id="buchung" aria-label="Anmeldung">
      <Reveal className="wrap" as="div">
        <h2 className="buchung-title">Jetzt anmelden</h2>
        <p className="buchung-intro">Sichere dir deinen Platz beim Live-Workshop.</p>

        <ValueStack />
        <Summary />
        <BookingForm />

        <div className="booking-alt" data-testid="booking-contact">
          <p>
            Lieber persönlich? Schreib uns per{" "}
            <a href={waLink} data-testid="booking-alt-whatsapp">
              WhatsApp
            </a>{" "}
            oder{" "}
            <a href={mailLink} data-testid="booking-alt-email">
              E-Mail
            </a>
            .
          </p>
        </div>
      </Reveal>
    </section>
  );
}
